import React, { useRef } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Button,
  ButtonGroup,
  VStack,
} from '@chakra-ui/react';
import { CreateTeamDrawerProps } from 'features/user-groups/components/CreateTeamDrawer/types';
import { AppAccessField } from 'features/user-groups/components/CreateTeamDrawer/components';
import { useAddAppsToGroup } from '../hooks/useAddAppsToGroup';
import { useDrawerStateDispatch } from 'features/main/context';

export const AddAppsDrawer: React.FC<CreateTeamDrawerProps> = () => {
  const initialFocusRef = useRef<HTMLInputElement>(null);
  const [{ drawerVisible, drawerId }] = useDrawerStateDispatch();
  const {
    tenantList,
    handleSubmit,
    isSubmitting,
    productAccessState,
    setProductAccessState,
    handleCloseDrawer,
  } = useAddAppsToGroup();

  const isOpen = drawerVisible && drawerId === 'add-apps-drawer';

  return (
    <Drawer
      isOpen={isOpen}
      onClose={handleCloseDrawer}
      initialFocusRef={initialFocusRef}
      size='lg'
    >
      <DrawerOverlay />
      <form onSubmit={handleSubmit} data-testid='add-apps-form'>
        <DrawerContent data-testid='add-apps-drawer'>
          <DrawerHeader display='flex' alignItems='center'>
            Add apps to the team
            <DrawerCloseButton />
          </DrawerHeader>
          <DrawerBody>
            <VStack spacing={6} align='stretch'>
              <AppAccessField
                tenantList={tenantList}
                productAccessState={productAccessState}
                setProductAccessState={setProductAccessState}
              />
            </VStack>
          </DrawerBody>
          <DrawerFooter justifyContent='flex-end'>
            <ButtonGroup>
              <Button
                variant='ghost'
                onClick={handleCloseDrawer}
                isDisabled={isSubmitting}
                data-testid='group-add-apps-cancel-button'
              >
                Cancel
              </Button>
              <Button
                type='submit'
                variant='solid'
                isLoading={isSubmitting}
                isDisabled={isSubmitting || !productAccessState.length}
                data-testid='group-add-apps-submit-button'
              >
                Save
              </Button>
            </ButtonGroup>
          </DrawerFooter>
        </DrawerContent>
      </form>
    </Drawer>
  );
};
